import {BaseService} from "../../domain-services/base-service";
import {AnimationDomainModel} from "../../../domain/common/animation/animation.domain-model";
import {BaseAnimationSetModel} from "./set-models/base-animation-set-model";
import {Type} from "../../type";

export class AnimationService extends BaseService {
  static injectables = [...BaseService.injectables];

  get animations(): Object<BaseAnimationSetModel> {
    throw new Error('must implement animations mapper: ' + this.constructor.name);
  }

  create(animationDomainModel: AnimationDomainModel): BaseAnimationSetModel {
    let animationSetModel: BaseAnimationSetModel = null;
    const animationSetModelType: Type<BaseAnimationSetModel> = this.animations[animationDomainModel.id];

    if(animationSetModelType) {
      animationSetModel = new animationSetModelType(animationDomainModel);
    }

    return animationSetModel;
  }

  start(animationDomainModel: AnimationDomainModel): BaseAnimationSetModel {
    if(!animationDomainModel) {
      return;
    }

    const animation: BaseAnimationSetModel = this.create(animationDomainModel);

    if(animation) {
      setTimeout(() => animation.start(), 0);
    }

    return animation;
  }
}
